<template>
    <div>
        <vx-card class="mb-4">
            <div class="w-full flex flex-no-wrap">
                <div class="w-1/2">
                    <h5 class="mb-4">Account Information</h5>
                    <div class="table-row w-full mb-5">
                        <div class="table-cell w-2/5 p-4">Company Legal Name</div>
                        <div class="table-cell w-3/5 p-4">: {{merchantInfo.name}}</div>
                    </div>
                    <div class="table-row w-full mb-5">
                        <div class="table-cell w-2/5 p-4">Brand Name</div>
                        <div class="table-cell w-3/5 p-4">: {{merchantInfo.brandName}}</div>
                    </div>
                    <div class="table-row w-full">
                        <div class="table-cell w-2/5 p-4">Company Email</div>
                        <div class="table-cell w-3/5 p-4">: {{merchantInfo.email}}</div>
                    </div>
                    <div class="table-row w-full">
                        <div class="table-cell w-2/5 p-4">Merchant Category</div>
                        <div class="table-cell w-3/5 p-4">: {{merchantInfo.merchant_category}}</div>
                    </div>
                    <div class="table-row w-full">
                        <div class="table-cell w-2/5 p-4">Phone Number</div>
                        <div class="table-cell w-3/5 p-4">: {{merchantInfo.phone}}</div>
                    </div>
                    <div class="table-row w-full">
                        <div class="table-cell w-2/5 p-4">Address</div>
                        <div class="table-cell w-3/5 p-4">: {{merchantInfo.address}}</div>
                    </div>
                    <div class="table-row w-full">
                        <div class="table-cell w-2/5 p-4">Director's Name</div>
                        <div class="table-cell w-3/5 p-4">: {{merchantInfo.directorName}}</div>
                    </div>
                    <div class="table-row w-full">
                        <div class="table-cell w-2/5 p-4">Registered Date</div>
                        <div class="table-cell w-3/5 p-4">: {{merchantInfo.registeredDate}}</div>
                    </div>
                    <div class="table-row w-full">
                        <div class="table-cell w-2/5 p-4">Status</div>
                        <div class="table-cell w-3/5 p-4">
                            <div class="vertical-center">
                                <vs-chip v-bind:color="statusColor">
                                    <vs-avatar style="background: hsla(0, 0%, 100%, .2)" v-bind:icon="statusIcon"/>
                                    {{statusText}}
                                </vs-chip>
                            </div>
                            <div class="vertical-center" v-if="statusText==='Waiting for verified'">
                              <br><br><br>
                                Thank you for your request. We will review your documents in maximum 2 working days.
                            </div>
                             <div class="vertical-center" v-else-if="statusText==='Rejected'">
                              <br><br><br>
                              {{merchantInfo.notes}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                    <img src="@/assets/images/pages/graphic-4.png" alt="login" class="mx-auto"/>
                </div>
            </div>
        </vx-card>

        <vx-card class="mb-4">
            <div class="w-full flex flex-no-wrap">
                <div class="w-1/2">
                    <h5 class="mb-4">Merchant Credential</h5>
                    <div class="table-row w-full">
                        <div class="table-cell w-1/4 p-4">Merchant Code</div>
                        <div class="table-cell w-3/4 p-4">: {{merchantCredential.merchantCode}}</div>
                    </div>
                    <div class="table-row w-full">
                        <div class="table-cell w-1/4 p-4">Secret Key</div>
                        <div class="table-cell w-3/4 p-4">: {{merchantCredential.merchant_encryption_key}}</div>
                    </div>
                </div>
                <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center"></div>
            </div>
        </vx-card>

        <vx-card>
            <div class="w-full text-right">
                <vs-button
                        type="border"
                        to="/account/verification"
                        v-if="(merchantInfo.status === '' || merchantInfo.status === null || merchantInfo.status === 'reject') && role !== 'root' && role !== 'administrator'"
                >
                    Request for
                    Verification
                </vs-button>
                <vs-button
                        class="ml-4" to="/account/update"
                        v-show="!true"
                        v-if="(merchantInfo.status === 'pending' || merchantInfo.status === 'active') && role !== 'root' && role !== 'administrator'">
                    Update Info
                </vs-button>
            </div>
        </vx-card>
    </div>
</template>

<script>
    import AuthAPI from "@/network/api/AuthAPI";

    export default {
        data() {
            return {
                role: localStorage.getItem("userRole"),
                merchantInfo: {
                    name: "",
                    brandName: "",
                    registeredDate: "",
                    email: "",
                    address: "",
                    directorName: "",
                    status: "",
                    phone: "",
                    merchant_category: "",
                    notes: ""
                },
                merchantCredential: {
                    merchantCode: "",
                    merchant_encryption_key: ""
                },
                statusColor: "",
                statusText: "",
                statusIcon: ""
            };
        },
        mounted() {
            AuthAPI.UserInfo().then(result => {
                //console.log(result.data.merchant)
                if (result.data !== null) {
                    for (let merchant of result.data.merchant) {

                            this.merchantInfo.id = merchant.id;
                            this.merchantInfo.name = merchant.full_name;
                            this.merchantInfo.brandName = merchant.brand_name;
                            this.merchantInfo.email = merchant.email;
                            this.merchantInfo.webAddress = merchant.url;
                            this.merchantCredential.merchantCode = merchant.code;
                            this.merchantInfo.registeredDate = merchant.created_at;
                            this.merchantInfo.status = merchant.status;
                            this.merchantInfo.phone = merchant.phone;
                            this.merchantInfo.notes = merchant.notes;

                            for (let merchant_categories of result.data.merchant_categories) {
                                if (merchant_categories.id == merchant.category_id) {
                                    this.merchantInfo.merchant_category = merchant_categories.name
                                }
                            }
                            if (
                                merchant.status !== "registered" &&
                                merchant.status !== null &&
                                merchant.status !== undefined
                            ) {
                                if (merchant.status === "pending") {
                                    this.statusColor = "warning";
                                    this.statusText = "Waiting for verified";
                                    this.statusIcon = "hourglass_full";
                                } else if (merchant.status === "reject") {
                                    this.statusColor = "danger";
                                    this.statusText = "Rejected";
                                    this.statusIcon = "close";
                                } else {
                                    this.statusColor = "success";
                                    this.statusText = "Verified";
                                    this.statusIcon = "verified_user";
                                }
                            } else {
                                this.statusColor = "dark";
                                this.statusText = "Active Pending";
                                this.statusIcon = "lock";
                            }
                            this.merchantCredential.merchant_encryption_key =
                                merchant.secret_key;
                            if (merchant.details !== null) {
                                if (merchant.details.address !== undefined)
                                    this.merchantInfo.address = merchant.details.address;
                                if (merchant.details.director_name !== undefined)
                                    this.merchantInfo.directorName = merchant.details.director_name;
                                if (merchant.details.director_identity_type !== undefined)
                                    this.merchantInfo.directorIdentityType =
                                        merchant.details.director_identity_type;
                                if (merchant.details.director_identity_number !== undefined)
                                    this.merchantInfo.directorIdentityNumber =
                                        merchant.details.director_identity_number;
                            }
                    }
                }
            });
        }
    };
</script>

<style>
    .vertical-center {
        position: absolute;
        margin-top: 9px;
        top: auto;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
</style>
